var Heros = {
    init: function(target) {
        
     $slider=  new Swiper(target, {
            lazyLoad: 'ondemand',
            slidesPerView: 1,
            slidesToScroll: 1,
            autoplay: $(target+' .hero-item').length>1?true:false,
            autoplaySpeed: 2000,
            navigation: false,
            autoHeight: false,
            loop: $(target+' .hero-item').length>1?true:false,
            speed: 500,
            effect: 'fade',
             pagination: {
              el: target+" .swiper-pagination",
              type: "fraction",
            }, 
            fadeEffect: {
                crossFade: true
              }
        });

        $(target+' .scroll-down').click(function(e){
          $("html, body").animate({ scrollTop: $(target).innerHeight() }, 500); 
          e.preventDefault();
        });
    
    }
}